import { useEffect, useRef, useState } from 'react';

import { cn } from '@/lib/utils';

// A hairline in the text colour that drains until `until`. It seeks to the time
// left, so a remount mid-window keeps the real deadline. Under reduced motion it is
// hidden and the text beside it carries the state. `className` places the track
export function Drain({
  until,
  className,
}: {
  until: number;
  className?: string;
}) {
  const fillRef = useRef<HTMLSpanElement>(null);
  const [deadline] = useState(until);

  useEffect(() => {
    const fill = fillRef.current;
    if (!fill || typeof fill.animate !== 'function') return;
    const animation = fill.animate(
      [{ transform: 'scaleX(1)' }, { transform: 'scaleX(0)' }],
      {
        duration: Math.max(deadline - Date.now(), 0),
        easing: 'linear',
        fill: 'both',
      }
    );
    return () => animation.cancel();
  }, [deadline]);

  return (
    <span
      aria-hidden="true"
      className={cn(
        'pointer-events-none absolute inset-x-0 overflow-hidden rounded-full bg-current/20 motion-reduce:hidden',
        className
      )}
    >
      <span
        ref={fillRef}
        className="block h-full w-full origin-left bg-current"
      />
    </span>
  );
}
